import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';

import enTranslation from './locales/en/translation.json';
import heTranslation from './locales/he/translation.json';

// Function to reload translations
export const reloadTranslations = () => {
  // Clear cache and reload resources
  i18n.reloadResources(['en', 'he']).then(() => {
    console.log('Translations reloaded successfully');
  }).catch(err => {
    console.error('Failed to reload translations:', err);
  });
};

// Force reload translations on init
setTimeout(() => {
  reloadTranslations();
}, 1000);

i18n
  // load translation using http -> see /public/locales
  // learn more: https://github.com/i18next/i18next-http-backend
  .use(Backend)
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    // Provide fallback resources in case HTTP backend fails
    resources: {
      en: {
        translation: enTranslation
      },
      he: {
        translation: heTranslation
      }
    },
    fallbackLng: 'en',
    debug: process.env.NODE_ENV === 'development',
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    react: {
      useSuspense: true,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
      requestOptions: {
        // Custom headers for backend HTTP requests
        cache: 'no-cache',
        headers: {
          'Content-Type': 'application/json'
        }
      },
      // Add custom parser to handle JSON parsing errors
      parse: (data) => {
        try {
          return JSON.parse(data);
        } catch (e) {
          console.error('Failed parsing translation file:', e);
          // Return embedded translations as fallback
          return e.message.includes('en') ? enTranslation : 
                 e.message.includes('he') ? heTranslation : {};
        }
      }
    }
  });

export default i18n;
